import React, { PureComponent as Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Col } from 'reactstrap';
import { TextRupiah } from '../../../../../Text';
import KredivoIcon from '../../../../../../images/kredivo-icon.png';
import propTypes from 'prop-types';
import Loading from '../../../../../Loading';

export default class KredivoTag extends Component{
    render(){
        const { data } = this.props.installments;
        if(this.props.installments.error){
            return null;
        }
        else if(this.props.installments.isSubmit===true)
            return <Loading width={30} height={30} />
        return (            
            <p className="installments">
                {

                    data!==undefined?
                    (data.installments.length>0?
                        (this.props.installments.data.installments[this.props.installments.data.installments.length-1].tenure>1?
                        <span className="text-kredivo">
                            or <TextRupiah value={this.props.installments.data.installments[this.props.installments.data.installments.length-1].monthly_installment.toString()} prefix="IDR " color="black" /> with 
                            <Col className="kredivo-icon-wrapper">
                              <KickImage className="kredivo-icon" style={{marginLeft: '0px'}} src={KredivoIcon} alt="Buy Now, Pay Later with Kredivo"/>
                            </Col>
                        </span>:null)
                    :null)
                    :null
                }                    
            </p>
            
        )
    }
}

KredivoTag.propTypes = {
    installments : propTypes.shape({
        isSubmit : propTypes.bool,
        data: propTypes.shape({
            installments: propTypes.array
        }),
        error: propTypes.object
    }).isRequired
}


// export default class KredivoTag extends Component{
//     render(){
//         if(!(this.props.price>=this.props.min&&this.props.price<=this.props.max))
//             return null;
//         return (
//             <p className="installments">
//                 atau mulai dari <TextRupiah value={Math.floor((this.props.price/this.props.type)+this.props.price*this.props.rate/100).toString()} prefix="IDR. "/>/bulan dengan <KickImage style={{marginLeft:10, width:50}} src={KredivoIcon} alt="Buy Now, Pay Later with Kredivo"/>
//             </p>
//         )
//     }
// }

// KredivoTag.propTypes = {
//     type : propTypes.number,
//     min : propTypes.number,
//     max : propTypes.number,
//     price : propTypes.number.isRequired,
//     rate : propTypes.number
// }
// KredivoTag.defaultProps = {
//     type : 12,
//     min : 1500000,
//     max : 25000000,
//     rate : 2.95
// }